import script from "./confirm-new.vue?vue&type=script&lang=ts&setup=true"
export * from "./confirm-new.vue?vue&type=script&lang=ts&setup=true"

import "./confirm-new.vue?vue&type=style&index=0&id=fd285b34&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd285b34"]])

export default __exports__